import React from 'react';
import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import { JsonLink } from './JsonLink';
import './LendingSupport.scss';

interface Props {
  deal?: Deal;
  onClick: (deal?: Deal) => void;
}

export const LendingSupportDeal: React.FC<Props> = ({ deal, onClick }) => {
  const dealId = deal?.id;
  return (
    <>
      <div>Deal:</div>
      <JsonLink
        data={deal}
        dataTestId={`deal-link-${dealId}`}
        onClick={() => onClick(deal)}
        text={dealId}
      />
    </>
  );
};
